/*
  PROFUNDIDAD CON EL RATÓN EN EL HERO — Cuadros Splash (8 sep 2026)

  Tres capas que se mueven a distinta velocidad siguiendo al ratón, y la
  escena gana profundidad:
    · la foto del dormitorio (lejos): se desplaza al contrario, poco
    · una luz cálida (medio): sigue al ratón, como si la lámpara respondiera
    · el lienzo 3D (cerca): se desplaza a favor, más

  Va con GSAP `quickTo`: cada capa persigue la posición con un retardo largo
  (1,5 s) y curva suave, así el movimiento es flotante, no nervioso. Gabriel
  quiere las animaciones lentas: si esto se percibe rápido, subir la
  duración de quickTo antes de tocar las distancias.

  Solo tiene sentido con ratón (hover + puntero fino) y en escritorio. Con
  movimiento reducido no se arma. Sin GSAP, no pasa nada: la foto, quieta.
  Nunca toca el <img> directamente: la foto lleva su propio zoom de 14 s
  sobre `transform`, y por eso cada capa es un envoltorio aparte.
*/
(function () {
  var hero = document.querySelector('.custom-hero');
  var media = hero && hero.querySelector('.custom-hero__media');
  if (!hero || !media) return;

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var urlGsap = document.currentScript && document.currentScript.dataset.gsap;

  /* GSAP ya suele estar en la página (lo trae la sección del sofá, más
     abajo). Se le da un margen; si no aparece, se carga una sola vez. */
  function conGsap() {
    if (window.gsap) return Promise.resolve();
    if (window.__csGSAP) return window.__csGSAP;
    window.__csGSAP = new Promise(function (res, rej) {
      var intentos = 0;
      var espera = setInterval(function () {
        if (window.gsap) { clearInterval(espera); return res(); }
        if (++intentos < 16) return; // 4 s
        clearInterval(espera);
        if (!urlGsap) return rej(new Error('sin GSAP'));
        var s = document.createElement('script');
        s.src = urlGsap;
        s.onload = function () { res(); };
        s.onerror = function () { rej(new Error('no se pudo cargar GSAP')); };
        document.head.appendChild(s);
      }, 250);
    });
    return window.__csGSAP;
  }

  function cuandoSobreTiempo(fn) {
    function luego() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 1200);
    }
    if (document.readyState === 'complete') luego();
    else window.addEventListener('load', luego, { once: true });
  }

  function armar() {
    var foto = media.querySelector('.custom-hero__capa--foto');
    var luz = media.querySelector('.custom-hero__capa--luz');
    if (!foto) return;

    var SUAVE = { duration: 1.5, ease: 'power3.out' };

    // Distancias máximas en px, por capa y eje. Lejos poco, cerca más.
    /* La sala es el fondo estable del lienzo: no debe desplazarse al pasar
       el cursor. Solo queda la luz ambiental, que no cambia la posición de
       ningún elemento de la escena. */
    var capas = [
      { el: luz,  dx: 26,  dy: 18 }
    ];
    // EL LIENZO 3D YA NO SE MUEVE CON EL RATÓN (19 sep 2026).
    // Aquí se le daban 22 px de lado y 14 de alto. Su capa va con `inset: 0`
    // y `.custom-hero__media` recorta, así que no tiene ni un píxel de
    // holgura: cualquier desplazamiento se come un trozo del cuadro por un
    // borde. Con el cuadro al 80 % del hueco, 14 px arriba es la cabeza de la
    // menina fuera. La sala (`--foto`) sí tiene holgura (`inset: -28px`) y
    // sigue moviéndose: la sala se mueve y el cuadro se queda, que es lo que
    // hace que parezca colgado. No se le da holgura a esta capa porque
    // hero-lienzo-3d.js la mide para encuadrar el modelo y cambiaría el
    // tamaño del cuadro.
    function conLienzo() { /* nada: se queda quieto a propósito */ }

    function prepara(c) {
      if (!c.el) return;
      c.x = gsap.quickTo(c.el, 'x', SUAVE);
      c.y = gsap.quickTo(c.el, 'y', SUAVE);
    }
    capas.forEach(prepara);

    // EL FOCO YA NO SE MUEVE POR VARIABLES CSS (19 sep 2026).
    // Aquí se animaban `--lx` y `--ly`, que van DENTRO del radial-gradient de
    // la capa (`at calc(var(--lx) * 1%) ...`). Mover la posición de un
    // degradado no es mover una capa: es volver a PINTARLA entera, en cada
    // fotograma. Y como la capa lleva `mix-blend-mode: screen`, el navegador
    // tenía además que volver a mezclarla con la foto de la sala que hay
    // debajo. El resultado es exactamente lo que Gabriel describió: la imagen
    // de fondo dando tirones al mover el ratón. El `will-change: transform`
    // que tiene la capa no ayudaba en nada, porque lo que cambiaba no era el
    // transform sino el dibujo.
    // La luz sigue siguiendo al ratón: lo hace con el mismo `x`/`y` que las
    // demás capas, ahí abajo en `capas`, y eso sí lo mueve el compositor sin
    // repintar nada.

    function mover(nx, ny) {
      capas.forEach(function (c) {
        if (!c.x) return;
        c.x(nx * c.dx);
        c.y(ny * c.dy);
      });
    }

    var rect = null;
    function medir() { rect = media.getBoundingClientRect(); }

    hero.addEventListener('pointerenter', function () { medir(); conLienzo(); });
    hero.addEventListener('pointermove', function (e) {
      if (!rect) medir();
      var nx = (e.clientX - (rect.left + rect.width / 2)) / (rect.width / 2);
      var ny = (e.clientY - (rect.top + rect.height / 2)) / (rect.height / 2);
      nx = Math.max(-1, Math.min(1, nx));
      ny = Math.max(-1, Math.min(1, ny));
      mover(nx, ny);
    });
    hero.addEventListener('pointerleave', function () { mover(0, 0); });
    window.addEventListener('resize', function () { rect = null; });

    media.classList.add('is-profundidad');
  }

  cuandoSobreTiempo(function () {
    conGsap().then(armar).catch(function (e) {
      if (window.console) console.warn('[hero-profundidad]', e);
    });
  });
})();
